import {
  COLORS,
  SPACING,
  FONT,
  DIMENSIONS,
  Z_INDEX,
} from "@assets/styles/styleConstants";

const headerContainer = {
  position: "fixed",
  zIndex: Z_INDEX.header,
  top: 0,
  borderColor: COLORS.gray300,
  width: "100%",
} as const;

const header = {
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
};

const logoContainer = {
  py: SPACING.small,
  alignItems: "center",
};

const logo = {
  height: DIMENSIONS.logoHeight,
  verticalAlign: "middle",
  mr: SPACING.medium,
};

const headerText = {
  fontSize: FONT.large,
  ml: SPACING.medium,
  color: COLORS.blackE6,
  lineHeight: "body",
};

const navContainer = {
  alignItems: "center",
  justifyContent: "flex-end",
};

const isVisibleOnMobile = {
  display: ["none", "none", "block", "block", "block", "block"],
};

const isVisibleOnDesktop = {
  display: ["none", "none", "none", "none", "block", "block"],
};

const navItemLink = {
  py: SPACING.small,
  px: SPACING.medium,
  fontWeight: FONT.lightWeight,
  color: COLORS.gray800,
  "&.is-hovered": {
    textDecoration: "none",
  },
  "&.is-focused": {
    textDecoration: "none",
  },
  "&.is-pressed": {
    textDecoration: "none",
  },
  "&.is-visited": {
    textDecoration: "none",
  },
};

const navItemAction = {
  ...navItemLink,
};

const dropdownMenu = {
  maxWidth: "unset",
  pl: "200px",
  p: SPACING.small,
  "& > li": {
    p: "0",
  },
};

const dropdownMenuItem = {
  textDecoration: "none",
  padding: ".675rem 1rem",
  pr: "2.25rem",
  "&.is-hovered": { textDecoration: "none" },
  "&.is-pressed": { textDecoration: "none" },
  "&.is-focused": { textDecoration: "none" },
  "&.is-visited": { textDecoration: "none" },
};

const helpListItem = {
  ...dropdownMenuItem,
  color: COLORS.gray700,
};

const supportLinks = {
  boxSizing: "border-box",
  margin: "0px",
  minWidth: "0px",
  backgroundColor: "transparent",
  textDecoration: "none",
  padding: "10px",
  outline: "none",
  cursor: "pointer",
  color: "gray-600",
  display: "flex",
  flexDirection: "column",
  ":hover": {
    backgroundColor: "gray-100",
    color: "gray-900",
  },
} as const;

export const headerSX = {
  headerContainer,
  header,
  logoContainer,
  logo,
  headerText,
  navContainer,
  isVisibleOnMobile,
  isVisibleOnDesktop,
  navItemLink,
  navItemAction,
  helpListItem,
  dropdownMenu,
  dropdownMenuItem,
  supportLinks,
};
